import React from 'react'

import Accordion from 'react-bootstrap/Accordion'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import ListGroupItem from 'react-bootstrap/ListGroupItem'

import cat from './cat.gif'

import { HeartFillIcon } from '@primer/octicons-react'
import { FaJava, FaNpm } from 'react-icons/fa'
import { BsCameraVideoFill } from 'react-icons/bs'

export default function ImpressPage() {

    const mediaResources = {
        'octicons': 'https://react-icons.github.io/react-icons/',
        'react-icons': 'https://octicons-primer.vercel.app',
        'icons8': 'http://icons8.com',
        'freepik': 'https://www.freepik.com'
    };

    const packages = {
        '@primer/octicons-react': 'https://www.npmjs.com/package/@primer/octicons-react',
        '@testing-library/jest-dom': 'https://www.npmjs.com/package/@testing-library/jest-dom',
        '@testing-library/react': 'https://www.npmjs.com/package/@testing-library/react',
        '@testing-library/user-event': 'https://www.npmjs.com/package/@testing-library/user-event',
        'ace-builds': 'https://www.npmjs.com/package/ace-builds/',
        'axios': 'https://www.npmjs.com/package/axios',
        'bootstrap': 'https://www.npmjs.com/package/bootstrap',
        'jquery': 'https://www.npmjs.com/package/jquery',
        'js-file-download': 'https://www.npmjs.com/package/js-file-download',
        'node-sass': 'https://www.npmjs.com/package/node-sass',
        'react': 'https://www.npmjs.com/package/react',
        'react-ace': 'https://www.npmjs.com/package/react-ace/',
        'react-bootstrap': 'https://www.npmjs.com/package/react-bootstrap/',
        'react-content-loader': 'https://www.npmjs.com/package/react-content-loader/',
        'react-papaparse': 'https://www.npmjs.com/package/react-papaparse',
        'react-dom': 'https://www.npmjs.com/package/react-dom',
        'react-dropzone': 'https://www.npmjs.com/package/react-dropzone/',
        'react-icons': 'https://www.npmjs.com/package/react-icons',
        'react-markdown': 'https://www.npmjs.com/package/react-markdown',
        'react-use-clipboard': 'https://www.npmjs.com/package/react-use-clipboard',
        'react-router': 'https://www.npmjs.com/package/react-router',
        'react-router-dom': 'https://www.npmjs.com/package/react-router-dom/',
        'react-toggle-dark-mode': 'https://www.npmjs.com/package/react-toggle-dark-mode',
        'react-scripts': 'https://www.npmjs.com/package/react-scripts/',
        'recharts': 'https://www.npmjs.com/package/recharts',
        'rehype-katex': 'https://www.npmjs.com/package/rehype-katex',
        'remark-gemoji': 'https://www.npmjs.com/package/remark-gemoji/',
        'remark-gfm': 'https://www.npmjs.com/package/remark-gfm/',
        'remark-highlight.js': 'https://www.npmjs.com/package/remark-highlight.js',
        'remark-hint': 'https://www.npmjs.com/package/remark-hint',
        'remark-images': 'https://www.npmjs.com/package/remark-images/',
        'remark-math': 'https://www.npmjs.com/package/remark-math',
        'remark-strip-badges': 'https://www.npmjs.com/package/remark-strip-badges',
        'remark-toc': 'https://www.npmjs.com/package/remark-toc/',
        'sweetaler2': 'https://www.npmjs.com/package/sweetalert2',
        'sweetforms': 'https://www.npmjs.com/package/@chronicstone/sweetforms'
    };

    const libraries = {
        'spring-boot-starter-web': 'https://search.maven.org/search?q=a:spring-boot-starter-web%20AND%20g:org.springframework.boot',
        'spring-boot-starter-validation': 'https://search.maven.org/search?q=a:spring-boot-starter-validation%20AND%20g:org.springframework.boot',
        'spring-boot-starter-thymeleaf': 'https://search.maven.org/search?q=a:spring-boot-starter-thymeleaf%20AND%20g:org.springframework.boot',
        'spring-boot-starter-security': 'https://search.maven.org/search?q=a:spring-boot-starter-security%20AND%20g:org.springframework.boot',
        'jjwt-api': 'https://search.maven.org/artifact/io.jsonwebtoken/jjwt-api',
        'jjwt-impl': 'https://search.maven.org/artifact/io.jsonwebtoken/jjwt-impl',
        'jjwt-jackson': 'https://search.maven.org/artifact/io.jsonwebtoken/jjwt-jackson',
        'mysql-connector-java': 'https://search.maven.org/artifact/mysql/mysql-connector-java',
        'gson': 'https://search.maven.org/artifact/com.google.code.gson/gson',
        'guava': 'https://search.maven.org/artifact/com.google.guava/guava'
    };

    return (
        <>
            <Row>
                <Col className="mb-3" sm={12} md={6} lg={6}>
                    <Card>
                        <Card.Header>
                            Informationen
                        </Card.Header>
                        <Card.Body>
                            <img className="d-block mb-3" src={cat} alt="" style={{maxWidth: "100%"}} />
                            <Card.Title>Entwickelt vom ICT-Campus</Card.Title>
                            <p>Manuel Ruwe, <a href="mailto:manuel.ruwe@bluewin.ch">Send mail</a></p>
                            <p>Campboard wurde vom ICT-Campus mit <HeartFillIcon className="heart-icon"/> und ☕ programmiert.</p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Verwendete Inhalte</Card.Title>
                            <p>Vielen Dank an alle Mitwirkenden bei diesen Projekten.</p>

                            <Accordion defaultActiveKey="0">
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0">
                                        <BsCameraVideoFill className="mr-2" /> Medien
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <ListGroup>
                                                {
                                                    Object.keys(mediaResources).map((resourceKey, index) => {
                                                        return <ListGroupItem key={index}>
                                                            <a href={mediaResources[resourceKey]} target="_blank" rel="noreferrer">{resourceKey}</a>
                                                        </ListGroupItem>
                                                    })
                                                }
                                            </ListGroup>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1">
                                        <FaNpm  className="mr-2" /> NPM Packages
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <ListGroup>
                                                {
                                                    Object.keys(packages).map((packageKey, index) => {
                                                        return <ListGroupItem key={index}>
                                                            <a href={packages[packageKey]} target="_blank" rel="noreferrer">{packageKey}</a>
                                                        </ListGroupItem>
                                                    })
                                                }
                                            </ListGroup>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="2">
                                        <FaJava  className="mr-2" /> Java Libraries
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body>
                                            <ListGroup>
                                                {
                                                    Object.keys(libraries).map((libraryKey, index) => {
                                                        return <ListGroupItem key={index}>
                                                            <a href={libraries[libraryKey]} target="_blank" rel="noreferrer">{libraryKey}</a>
                                                        </ListGroupItem>
                                                    })
                                                }
                                            </ListGroup>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
